import {IProviderRoutes} from "../interfaces/provider";
import Provider from "./new/provider";
import {Constructor} from "../../global/constructor";
import {IServerData} from "../interfaces/serverInterfaces";
import {HTTPMethod} from "./new/httpMethod";
import Mapping from "../models/mapping/mapping"
import {RouteHelper} from "../helpers/routeHelper";
import {Route} from "../enums/route";

interface IMappingProviderRoutes {
  create: string;
  publishingDependencies: Route;
  fetchPublishedMapping: Route
  publish: Route;
  linkedModelData: Route;
}

export default class MappingProvider<T extends Mapping = Mapping> extends Provider<T> {
  routes: IProviderRoutes & IMappingProviderRoutes;

  constructor(protected modelType: Constructor<T>, public modelRoot: string, public collectionRoot: string) {
    super(modelType, modelRoot, collectionRoot);
    let newRoutes: IMappingProviderRoutes = {
      create: RouteHelper.path({route: Route.mapping}),
      fetchPublishedMapping: Route.mappingPublishedMapping,
      publishingDependencies: Route.mappingPublishingDependencies,
      publish: Route.publishMapping,
      linkedModelData: Route.mappingLinkedModelData,
    };
    Object.assign(this.routes, newRoutes);
  }

  create({organizationId, folderIdTree, mapping}: { organizationId: string, folderIdTree: string, mapping: object }): Promise<IServerData<any>> {
    const json = {
      organization_id: organizationId,
      folder_id_tree: folderIdTree,
      mapping: mapping,
    };
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.routes.create,
        method: HTTPMethod.POST,
        json: json,
      }).then(resolve);
    });
  }

  fetchRoot({ mappingId, rootModelId, rootModelType }): Promise<IServerData<any>> {
    const json = {};
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: RouteHelper.path({
          route: this.routes.linkedModelData,
          modelOrId: mappingId,
          namedWildcardOptions: [{ wildcard: ':linked_model_id', modelOrId: rootModelId }],
          query: { model_type: rootModelType },
        }),
        method: HTTPMethod.GET,
        json: json,
      }).then(resolve);
    });
  }

  publishingDependencies(obj: T): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: RouteHelper.path({route: this.routes.publishingDependencies, modelOrId: obj}),
        method: HTTPMethod.GET,
      }).then(resolve)
    })
  }

  fetchPublished(obj: T): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: RouteHelper.path({route: this.routes.fetchPublishedMapping, modelOrId: obj}),
        method: HTTPMethod.GET,
      }).then(resolve)
    })
  }

  publish(obj: T): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: RouteHelper.path({route: this.routes.publish, modelOrId: obj}),
        method: HTTPMethod.POST,
      }).then(resolve)
    })
  }
}